import type { Observable } from 'rxjs';
import type { SystemDomain } from '@integrations/system-domains/contracts/system-domain.contract';

import { Injectable, InjectionToken, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { parseResponse } from '@integrations/shared/parse-response';
import { SystemDomainCollectionResponseSchema } from '@integrations/system-domains/contracts/system-domain.contract';

export const LANDINGS_SERVICE_API_BASE = new InjectionToken<string>('LANDINGS_SERVICE_API_BASE', {
    providedIn: 'root',
    factory: () => '/api/landings-service',
});

@Injectable({ providedIn: 'root' })
export class SystemDomainsApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(LANDINGS_SERVICE_API_BASE);

    public getSystemDomains(): Observable<SystemDomain[]> {
        return this.http.get<unknown>(`${this.baseUrl}/system-domains`).pipe(
            map((res) =>
                parseResponse(res, SystemDomainCollectionResponseSchema, {
                    endpoint: 'system-domains',
                    method: 'GET',
                })
            )
        );
    }
}
